import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './pwa/registerSW';
import { AuthProvider } from './contexts/AuthContext';
import { CompanyProvider } from './contexts/CompanyContext';
import { I18nProvider } from './contexts/I18nContext';
import { ToastProvider } from './components/Toast';
import { OfflineProvider } from './contexts/OfflineContext';
import { BrandingProvider } from './contexts/BrandingContext';
import { CompanyFeaturesProvider } from './contexts/CompanyFeaturesContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Setup2FA from './pages/Setup2FA';
import PrivacyPolicy from './pages/PrivacyPolicy';
import SimpleDashboard from './components/SimpleDashboard';
import RealtimeNotificationsWrapper from './components/RealtimeNotificationsWrapper';
import PwaOverlays from './components/pwa/PwaOverlays';
import './App.css';

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <OfflineProvider>
          <ToastProvider>
            <RealtimeNotificationsWrapper>
              <Router>
                <PwaOverlays />
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/privacy" element={<PrivacyPolicy />} />
                  <Route
                    path="/setup-2fa"
                    element={
                      <ProtectedRoute>
                        <Setup2FA />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <CompanyProvider>
                          <CompanyFeaturesProvider>
                            <BrandingProvider>
                              <SimpleDashboard />
                            </BrandingProvider>
                          </CompanyFeaturesProvider>
                        </CompanyProvider>
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/dashboard"
                    element={
                      <ProtectedRoute>
                        <CompanyProvider>
                          <CompanyFeaturesProvider>
                            <BrandingProvider>
                              <SimpleDashboard />
                            </BrandingProvider>
                          </CompanyFeaturesProvider>
                        </CompanyProvider>
                      </ProtectedRoute>
                    }
                  />
                  {/* Rota catch-all para evitar 404 em refresh */}
                  <Route
                    path="*"
                    element={
                      <ProtectedRoute>
                        <CompanyProvider>
                          <CompanyFeaturesProvider>
                            <BrandingProvider>
                              <SimpleDashboard />
                            </BrandingProvider>
                          </CompanyFeaturesProvider>
                        </CompanyProvider>
                      </ProtectedRoute>
                    }
                  />
                </Routes>
              </Router>
            </RealtimeNotificationsWrapper>
          </ToastProvider>
        </OfflineProvider>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
